import Link from '@/atoms/Link/Link'
import ElevateLogo from './ElevateLogo'

/* assets */
import { ReactComponent as FacebookIcon } from 'public/assets/elevate-generative-ai/icons/facebook.svg'
import { ReactComponent as TwitterIcon } from 'public/assets/elevate-generative-ai/icons/twitter.svg'
import { ReactComponent as LinkedInIcon } from 'public/assets/elevate-generative-ai/icons/linkedin.svg'
import clsx from 'clsx'

const URL = `${process.env.NEXT_PUBLIC_BASE_URL}/elevate-generative-ai/`
const SHARE_TEXT =
  encodeURI(`I just signed up for Elevate! Join me at the ultimate global content summit of 2023. It’s free 🙌
${URL} @pepper__inc`)

interface Props {
  mode?: 'light' | 'dark'
}

function ElevateFooter({ mode = 'light' }: Props): JSX.Element {
  return (
    <div
      className={clsx(
        mode === 'dark' ? 'bg-[#070425] text-white' : 'text-gray-90'
      )}
    >
      <div className="max-width-container | flex flex-col gap-2 justify-between items-center lg:flex-row | py-12">
        <div className="font-medium | space-x-12">
          <Link href="/elevate-generative-ai/#speakers">Speakers</Link>
          <Link href="/elevate-generative-ai/#schedule">Schedule</Link>
        </div>

        <Link
          href="/elevate-generative-ai/"
          className="lg:absolute lg:left-1/2 lg:transform lg:-translate-x-1/2"
        >
          <ElevateLogo alignment="vertical" />
        </Link>

        <div className="flex items-center">
          <span className="mr-4">Share this event</span>
          <div
            className={clsx(
              'flex items-center | space-x-5',
              mode === 'dark' ? 'text-white' : 'text-black'
            )}
          >
            <a
              href={`https://www.facebook.com/sharer/sharer.php?quote=${SHARE_TEXT}&u=${URL}`}
              target="_blank"
              rel="noreferrer noopener"
              title="Facebook"
            >
              <FacebookIcon width="28" height="28" />
            </a>
            <a
              href={`https://twitter.com/share?text=${SHARE_TEXT}`}
              target="_blank"
              rel="noreferrer noopener"
              title="Twitter"
            >
              <TwitterIcon width="28" height="28" />
            </a>
            <a
              href={`https://www.linkedin.com/shareArticle?mini=true&title=${SHARE_TEXT}&url=${URL}`}
              target="_blank"
              rel="noreferrer noopener"
              title="Linkedin"
            >
              <LinkedInIcon width="28" height="28" />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ElevateFooter
